import React from 'react';
import {
  Dropdown,
  Button,
  Icon,
  DropdownMenu,
  DropdownContent,
  DropdownItemLink,
  ArrowDown,
} from '../../StyleComponents/styles';

const DropDownList = ({ dopDownList, title }) => {
  return (
    <Dropdown className="mb-4">
      <Button aria-haspopup="true" aria-controls="dropdown-menu">
        {title}
        <Icon>
        <ArrowDown />
        </Icon>
      </Button>
      <DropdownMenu id="dropdown-menu" role="menu">
        <DropdownContent>
          {dopDownList.map((e, index) => {
            return (
              <DropdownItemLink key={index} to={`/${e.link}/`} activeClassName="activeL">
                {e.name}
              </DropdownItemLink>
            );
          })}
        </DropdownContent>
      </DropdownMenu>
    </Dropdown>
  );
};
export default React.memo(DropDownList);
